import { Controller } from '@hotwired/stimulus'
import {
  iniciaSesionDeRegistro,
  cierraSesionDeRegistro,
  emiteMetodoElegido,
  METODO_GOOGLE
} from 'lib/analitica_del_registro'

// Analítica de PÁGINA de `/registro` (PRD-134-1, TC-134-1.4.5.3).
//
// Se monta en el contenedor de la pantalla (`usuarios/new.html.haml`) y hace tres
// cosas, todas fuera del formulario de correo y contraseña:
//
//   1. abre la sesión de página y emite `signup_view`;
//   2. emite los `signup_field_error` que el servidor acaba de rechazar, que
//      llegan resueltos en el contexto (`Analitica::Embudo::ErroresDelRegistro`);
//   3. emite `signup_method_clicked` con `google` al pulsar el botón de OAuth.
//
// Los eventos del formulario en sí —foco, errores en vivo, veredictos del nombre y
// envío— los emite `RegistroController`, que es quien ya conoce esos momentos.
//
// Va DELANTE en el DOM del formulario a propósito: Stimulus conecta en orden de
// documento, así que la sesión está abierta antes de que el formulario pueda
// emitir nada. Aunque no lo estuviera, las funciones del módulo son no-ops sin
// sesión y la analítica nunca rompería el flujo que mide.
export default class AnaliticaRegistroController extends Controller {
  static values = { contexto: Object }

  connect () {
    const { source, triggerAction, errores } = this.contextoValue || {}

    iniciaSesionDeRegistro({ source, triggerAction, errores })
  }

  disconnect () {
    cierraSesionDeRegistro()
  }

  // La acción cuelga del bloque y no del botón (ver `usuarios/new.html.haml`), así que solo cuenta
  // el clic que de verdad pulsa el botón: uno en el relleno del bloque no sale de la página y
  // contarlo diría "eligió Google y nunca completó".
  eligeGoogle (evento) {
    if (!evento.target.closest('button')) return

    emiteMetodoElegido(METODO_GOOGLE)
  }
}
